var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "section-title",
        { staticClass: "mt-6", attrs: { icon: "mdi-server" } },
        [_vm._v("EQUIPOS")]
      ),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.isValid,
            callback: function($$v) {
              _vm.isValid = $$v
            },
            expression: "isValid"
          }
        },
        [
          _c("v-data-table", {
            staticClass: "fs-10 text-uppercase elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.equipments,
              "no-data-text": "No hay equipos disponibles",
              "hide-default-footer": "",
              "disable-pagination": ""
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(ref) {
                  var item = ref.item
                  var headers = ref.headers
                  var index = ref.index
                  return [
                    _c(
                      "tr",
                      _vm._l(headers, function(header, key) {
                        return _c(
                          "td",
                          {
                            key: key,
                            staticClass:
                              "pa-0 px-1 caption d-block d-sm-table-cell align-content-center"
                          },
                          [
                            header.text === "EQUIPO"
                              ? _c("div", { staticClass: "caption pa-3" }, [
                                  _vm._v(
                                    " " + _vm._s(item.equipment.name) + " "
                                  )
                                ])
                              : _vm.equipmentsData[index][header.text]
                              ? _c("v-text-field", {
                                  staticClass: "value-field",
                                  attrs: {
                                    "hide-details": "",
                                    outlined: "",
                                    dense: "",
                                    flat: "",
                                    rules: [_vm.rules.allowedDecimals()],
                                    placeholder: header.measureUnit
                                  },
                                  model: {
                                    value:
                                      _vm.equipmentsData[index][header.text]
                                        .value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.equipmentsData[index][header.text],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "equipmentsData[index][header.text].value"
                                  }
                                })
                              : _c("v-text-field", {
                                  staticClass: "value-field",
                                  attrs: {
                                    "hide-details": "",
                                    outlined: "",
                                    dense: "",
                                    flat: "",
                                    placeholder: header.measureUnit,
                                    "background-color": "#eee",
                                    disabled: "",
                                    readonly: ""
                                  }
                                })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "my-6", attrs: { justify: "end", "no-gutters": "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "white--text",
              attrs: { color: "green", loading: _vm.isLoading },
              on: {
                click: function() {
                  return _vm.register()
                }
              }
            },
            [
              _c("v-icon", { staticClass: "ml-1" }, [_vm._v("mdi-check-all")]),
              _vm._v(" REGISTRAR ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }